"use strict";
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const lodash_merge_1 = __importDefault(require("lodash.merge"));
const processor_1 = require("@eva-design/processor");
const styleProvider_component_1 = require("../style/styleProvider.component");
const modalPanel_component_1 = require("../modal/modalPanel.component");
/**
 * `ApplicationProvider` component is designed to be a root of the application.
 *
 * This does basically two things:
 * - Provides styles for basic components;
 * - Renders modal window which is used to be common for all elements presented as modal;
 *
 * @extends React.Component
 *
 * @property {SchemaType} mapping - Determines the mapping for basic components.
 * This is designed to be provided from any `@eva-design/*` package (e.g. `@eva-design/eva`)
 * If provided, will be merged with customMapping to bootstrap eva during the runtime.
 *
 * @property {CustomSchemaType} customMapping - Determines the customized mapping.
 * This is merged with `mapping` property and designed to be used components customization.
 *
 * @property {ThemeType} theme - Determines the theme for basic components.
 * This is designed to be provided by developers team and can be imported from npm package (e.g. `@eva-design/eva`).
 *
 * @property {ThemeStyleType} styles - Determines the styles compiled by bootstrapping eva.
 * If provided, will replace runtime styles calculation.
 * Should be used with `@ui-kitten/metro-config` package.
 *
 * @property {ReactNode} children - Determines application root component.
 *
 * @overview-example Simple Usage
 *
 * ```
 * import React from 'react';
 * import { ApplicationProvider, Layout, Text } from '../..';
 * import * as eva from '@eva-design/eva';
 *
 * export default () => (
 *   <ApplicationProvider {...eva} theme={eva.light}>
 *     <Layout style={{ flex: 1 }}>
 *       <Text>Welcome to UI Kitten</Text>
 *     </Layout>
 *   </ApplicationProvider>
 * );
 * ```
 */
class ApplicationProvider extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = {
            styles: this.props.styles,
        };
        this.schemaProcessor = new processor_1.SchemaProcessor();
        this.createStyles = (mapping, custom) => {
            const customizedMapping = lodash_merge_1.default({}, mapping, custom);
            return this.schemaProcessor.process(customizedMapping);
        };
        if (!this.state.styles) {
            const { mapping, customMapping } = this.props;
            this.state.styles = this.createStyles(mapping, customMapping);
        }
    }
    render() {
        return (react_1.default.createElement(styleProvider_component_1.StyleProvider, { theme: this.props.theme, styles: this.state.styles },
            react_1.default.createElement(modalPanel_component_1.ModalPanel, null, this.props.children)));
    }
}
exports.ApplicationProvider = ApplicationProvider;
//# sourceMappingURL=applicationProvider.component.js.map